import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, Province } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-state-list',
  templateUrl: './epbt-fa-state-list.component.html',
  styleUrls: ['./epbt-fa-state-list.component.scss']
})
export class EpbtFaStateListComponent implements OnInit {

  @Input() states: any;
  @Input() readonly: boolean;

  @Input()
  selectedStateId: Province;

  @Output() selectedStateIdChange = new EventEmitter<any>();

  constructor(private client: FieldAgentClient) { }

  ngOnInit(): void {
    this.GetState();
  }

  onSelectionChange(selectedValue: any) {
    this.selectedStateId = selectedValue;
    this.selectedStateIdChange.emit(this.selectedStateId);
  }

  GetState() {
    this.client.getBisTrackProvinces().subscribe(res => {
      this.states = res;
      let province = new Province();
      province.provinceId = -1;
      province.name = "Not Selected";
      this.states.unshift(province);
      if (this.states.length > 0) {
        this.selectedStateId = this.states[0];
        this.selectedStateIdChange.emit(this.states[0]);
      }
    });
  }
}
